import { Transition } from '@uirouter/angular';

export function resolveStateParamsFn(trans) {
  return trans.params();
}

export let resolveStateParams = {
  token: 'stateParams',
  deps: [Transition],
  resolveFn: resolveStateParamsFn
};



// WEBPACK FOOTER //
// ./src/app/global/resolves/params.resolve.ts